<script lang="ts">
import { useUrlSearchParams } from '@vueuse/core'
import { defineComponent } from 'vue'

import RegisterSignInForm from '../forms/RegisterSignInForm.vue'

export default defineComponent({
  components: {
    RegisterSignInForm,
  },
  props: {
    checkOnLoad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedAction: 'register',
      callbackAfterAction: undefined as undefined | (() => any),
      isLoading: false,
      open: false,
    }
  },
  mounted() {
    if (this.checkOnLoad && this.$userStore.isLoggedOut) {
      this.openRegisterSignUpModalOnLoad()
    }
  },
  methods: {
    openModalWithSelectedAction(
      selectedAction: string,
      openModal: () => void,
      callbackAfterAction?: () => any
    ) {
      this.selectedAction = selectedAction
      this.callbackAfterAction = callbackAfterAction
      openModal()
      this.open = true
    },
    async closeModalWithRedirect(
      closeModal: (forceDismissal: boolean) => void
    ) {
      if (this.callbackAfterAction) {
        await this.callbackAfterAction()
      } else {
        await this.$router.push({
          name: this.$router.currentRoute.value.name?.toString() ?? 'home',
          replace: this.$router.currentRoute.value.name ? true : false,
        })
      }
      closeModal(true)
      this.open = false
    },
    setIsLoading(isLoading: boolean) {
      this.isLoading = isLoading
    },
    openRegisterSignUpModalOnLoad() {
      const queryParams = useUrlSearchParams()

      const register = 'register' in queryParams
      const signIn = 'signin' in queryParams

      if (register) {
        this.selectedAction = 'register'
        this.open = true
      } else if (signIn) {
        this.selectedAction = 'login'
        this.open = true
      }
    },
  },
})
</script>

<template>
  <AppModal
    id="signup-signin-modal"
    class="max-h-[95vh] min-h-[40vh]"
    button-class="w-full"
    :allow-dismissal="!isLoading"
    :open="open"
  >
    <template #button="{ openModal }">
      <!-- Store the open function reference -->
      <slot
        name="button"
        :open-modal="
          (selectedAction: string, callbackAfterAction?: () => any) =>
            openModalWithSelectedAction(
              selectedAction,
              openModal,
              callbackAfterAction
            )
        "
      >
        <slot v-if="$userStore.isLoggedIn" name="loggedIn" />
        <slot v-if="$userStore.isLoggedOut" name="loggedOut" />
      </slot>
    </template>

    <template #default="{ closeModal }">
      <RegisterSignInForm
        :id="`${$attrs.id ?? 'signup-signin-modal'}-form`"
        :selected-action="selectedAction"
        @is-loading="setIsLoading"
        @submit-login="(_) => closeModalWithRedirect(closeModal)"
        @submit-register="(_) => closeModalWithRedirect(closeModal)"
        @open-forgot-password-drawer="(_) => closeModal(true)"
      />
    </template>
  </AppModal>
</template>
